import DateRange from "./DateRange";
import TimeRange from "./TimeRange";

const DatePicker = { DateRange, TimeRange };

export default DatePicker;
